import { PagedRequestDto } from '../paged-request.model';
import { ContractorCitationStatus } from '../../enums/contractor-citation-status.enum';

export interface ContractorCitationSearchDto extends PagedRequestDto {
  status?: ContractorCitationStatus | null;
  facilityId?: string | null;
  facilityIds?: string[] | null;
  contractorId?: string | null;
}
